import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pageLoaded: false,
    isAnimated: false,
  },
  mutations: {
    setPageStatus(state, status) {
      state.pageLoaded = status;
    },
    setIsAnimated(state, status) {
      state.isAnimated = status;
    },
  },
  actions: {
    setPageStatus({ commit }, isLoaded) {
      commit('setPageStatus', isLoaded);
    },
    setIsAnimated({ commit }, isLoaded) {
      commit('setIsAnimated', isLoaded);
    },
  },
  getters: {
    pageLoaded: state => state.pageLoaded,
    isAnimated: state => state.isAnimated,
  },
});
